<template>
 <div id="personaldata">
 	<mt-header title="个人资料"  fixed>
		  <a href="javascript:void(0)" slot="left" @click="returnBack">
		    <mt-button icon="back" class="font-Yahei"></mt-button>
		  </a>
	</mt-header>
	<div class="bgcontent mt40"> 
		<div @click="updataInfo(nickname,0,namenicheng)">
	     <mt-cell :title="namenicheng"  is-link :value="nickname!=''?nickname:'未设置'" class="border-bottom-line"></mt-cell>
	    </div>
	    <div @click="selectSex">
	     <mt-cell :title="sexa"  is-link :value="sex!=-1?sex:'未设置'" class="border-bottom-line"></mt-cell>
	    </div>
	    <mt-popup v-model="sexVisible" position="bottom">
	         <mt-picker :slots="sexSlots" @change="sexValuesChange" :showToolbar="true" :visibleItemCount="showVisible" valueKey="name">
	       	   <span class="float-left colorff8900"  @click="cancelSex">取消</span>
	       	   <span class="color333">选择性别</span>
	       	   <span class="float-right colorff8900" @click="confirmSex">完成</span>
	         </mt-picker>
	    </mt-popup>
	    <p class="colorBox bordertopandbottom"></p>
	    <div @click="updataInfo(email,1,Mailname)">
	     <mt-cell :title="Mailname" is-link :value="email!=''?email:'未设置'" class="border-bottom-line"></mt-cell>
	    </div>
	    <div @click="updataInfo(phonenum,2,phonenumtitle)">
	     <mt-cell title="手机绑定" is-link :value="phonenum" class="border-bottom-line"></mt-cell>
	    </div>
	    <!--<mt-cell title="关于我们" to="/UserCenter/aboutUs" is-link class="border-bottom-line">
			  <img slot="icon" src="../../../static/images/about_ico.png" width="24" >
		</mt-cell>-->
	</div>
	<p class="precent80 mt40"><input type="button" value="退出登录" class="btnLogin" @click="loginOut"/></p>
 </div>
</template>

<script>
  import { Toast } from 'mint-ui'
  export default{
		data(){
			return{
			   namenicheng:"昵称",
			   sexa:"性别",
			   Mailname:"E-Mail",
			   phonenumtitle:"更换手机号",
			   nickname:"",
			   sex:"",
			   email:"",
			   gender:"",
			   username:localStorage.getItem("username"),
			   sexArry: [{"id":0,"name":'男'},{"id":1,"name":'女'}],
			   sexSlots:[
			     {
			     	values:[],
			     }
			   ],
			   sexVisible:false,
			   showVisible:3,
			   setSexId:"",
			   setSexName:""
			}
		},
		created:function(){
			this.showData();
	    },
	    computed:{
			 phonenum:function(){
			 	 return this.username.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
			 }
		},
	    methods: {
	       returnBack(){
	       	 this.$router.push({path: "/UserCenter"});
	       },
	       showData(){
	       	  this.$http.post(this.URL_PREFIX+"/user/findUserDataById.net",{uName:this.username})
		  	   .then((res) =>{
		  	     this.nickname=res.data.obj.name;
		  	     this.gender=res.data.obj.gender;
		  	     this.email=res.data.obj.email;
		  	     if(this.gender!=-1 && this.gender==0){
		  	     	this.sex="男";
		  	     }else if(this.gender!=-1 && this.gender==1){
		  	     	this.sex="女";
		  	     }else{
		  	     	this.sex=this.gender;
		  	     }
		  	  });
	       },
	       updataInfo(msg,type,titlename){
	       	  this.$router.push({path:'/UserCenter/personalUpdata',query:{content:msg,type:type,titleneme:titlename}});
	       },
	       selectSex(){
	       	 this.sexVisible=true;
	       	 this.sexSlots[0].values=this.sexArry;
	       	 if(this.gender==-1){
	       	 	this.sexSlots[0].defaultIndex=0;
	       	 }else{
	       	 	this.sexSlots[0].defaultIndex=this.gender;
	       	 }
	       },
	       cancelSex(){
	       	 this.sexVisible=false;
	       },
	       confirmSex(){
	       	 this.gender=this.setSexId;
	       	 this.$http.post(this.URL_PREFIX+"/user/saveUserData.net",{uName:this.username,gender:this.gender})
		  	    .then((res) =>{
			  	     if(res.data.code==200){
			  	     	this.sex=this.setSexName;
			  	     	Toast(res.data.msg);
			  	      }else{
			  	      	Toast(res.data.msg);
			  	      }
		  	 });
	       	  this.sexVisible=false;
	       },
	       sexValuesChange(values){
	       	 if(values.getValues()[0]!=undefined){
	       	 	this.setSexId=values.getValues()[0].id;
	       	 	this.setSexName=values.getValues()[0].name;
	       	 }
	       },
	       //退出登录
	       loginOut(){
            this.$http.post(this.URL_PREFIX+"/user/exitUserLogin.net",{phone:this.username})
			.then((res) =>{
				Toast(res.data.msg);
				if(res.data.code==200){
				  localStorage.removeItem("username");
          	      this.$router.push({path: '/'});
            	}
			});
	       }
	    }
	}
	
</script>

<style>
@import "../../../static/css/user.css";
.mint-cell-value span{margin-right: 10px;}
.precent80{width: 90%;margin: 10px auto;}
.picker-toolbar{text-align: center;}
.bordertopandbottom{border-bottom: 1px solid #eee;border-top: 1px solid #eee;}
</style>


// WEBPACK FOOTER //
// src/views/UserCenter/personalData.vue